import { bindActionCreators } from 'redux';
import { connect } from 'react-redux'
import {fetchTerminals} from '../actions/terminal'
import {fetchSettings} from '../actions/setting'
import {fetchOsSettings} from '../actions/ossetting'
import AccountNew from '../components/AccountNew';

const mapStateToProps = state => {
  const { terminal } = state
  const { setting } = state
  const {
    isFetching,
    lastUpdated,
    items,
    totalRows
  } = terminal || {
    isFetching: true,
    items: []
  }

  const usersMaster = setting.items || [];

  return {
    items,
    isFetching,
    lastUpdated,
    totalRows,
    usersMaster
  }
}

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getTerminals: fetchTerminals,
      getSettings: fetchSettings,
      getOsSettings: fetchOsSettings
    },
    dispatch,
  );

export default connect(mapStateToProps, mapDispatchToProps)(AccountNew)
